import type {
  ValidatedCreateEmployeeContractFormData,
  LC_CreateEmployeeContractIn,
} from '../types/employeeContractCreate.types';


/**
 * Maps validated form data to transport DTO for API
 * Transforms dates from yyyy-mm-dd to ISO date-time format for backend
 */
export function mapCreateEmployeeContractFormToTransport(
  formData: ValidatedCreateEmployeeContractFormData,
): LC_CreateEmployeeContractIn {
  // Format dates: yyyy-mm-dd -> ISO date-time format (yyyy-mm-ddT00:00:00) for .NET backend
  const formatDateForApi = (date: string): string => `${date}T00:00:00`;

  // For fixed-term contracts, contractEndDate2 must match contractEndDate
  const formattedEndDate = formData.contractEndDate
    ? formatDateForApi(formData.contractEndDate)
    : undefined;

  return {
    contractNumberREX: Number(formData.contractNumber),
    contractNameREX: formData.contractName || null,
    employeeContractTypeId: formData.contractTypeId,
    dateEntry: formatDateForApi(formData.dateEntry),
    contractStartDate: formatDateForApi(formData.contractStartDate),
    contractEndDate: formattedEndDate,
    contractEndDate2: formattedEndDate, // Backend requires this for fixed-term contracts
    contractModalityId: formData.contractModalityId,
    companyContractId: formData.companyContractId,
    positionId: formData.positionId,
    costCenterId: formData.costCenterId,
    unionCode: formData.unionCode ?? null,
  };
}
